import { currencyFormatter } from "mrb/common/formatting";
import { isNil } from "lodash";

// Formats a currency amount that the API may not have sent at all, keeping "absent" visually
// distinct from a genuine zero.
//
// This matters for producer report revenue: an event that is not allowed for payout carries a real
// zero, and an event inside a group that received the $0.01 minimum may legitimately be zero too. So
// $0.00 is meaningful data and must not double as "this field is missing". Intl.NumberFormat would
// blur exactly that line — it coerces null to $0.00 and renders undefined as $NaN — hence the guard.
//
// The dash placeholder matches the existing fallback used for absent playback time in the report cell.
export default function formatOptionalCurrency(value, { currency = "USD", placeholder = "-" } = {}) {
    if (isNil(value)) {
        return placeholder;
    }

    return currencyFormatter.format(value, { currency });
}
